var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    attrs: {
      inline: true
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "日期"
    }
  }, [[_c("data-options", {
    attrs: {
      clearable: false
    },
    model: {
      value: _vm.dateInfo,
      callback: function callback($$v) {
        _vm.dateInfo = $$v;
      },
      expression: "dateInfo"
    }
  })]], 2), _c("el-form-item", {
    attrs: {
      label: "服务器列表"
    }
  }, [_c("server-list", {
    attrs: {
      isCache: "",
      multiple: true,
      all: ""
    },
    model: {
      value: _vm.serverInfo,
      callback: function callback($$v) {
        _vm.serverInfo = $$v;
      },
      expression: "serverInfo"
    }
  })], 1), _c("el-form-item", {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn() {
        return [_c("el-button", {
          attrs: {
            type: "primary"
          },
          on: {
            click: function click($event) {
              return _vm.onSearchBtn();
            }
          }
        }, [_vm._v(" 查询 ")])];
      },
      proxy: true
    }])
  })], 1), _c("el-table", {
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "关卡",
      prop: "guanqia_no",
      align: "center"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "通关角色数",
      prop: "role_win_num",
      align: "center"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "通关角色留存",
      prop: "role_win_retention",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var row = _ref.row;
        return [_vm._v(" " + _vm._s(row.role_win_retention) + " （" + _vm._s(_vm.getPercent(row.role_win_retention, row.role_win_num)) + "%） ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "失败角色数",
      prop: "role_lose_num",
      align: "center"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "失败角色留存",
      prop: "role_lose_retention",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var row = _ref2.row;
        return [_vm._v(" " + _vm._s(row.role_lose_retention) + " （" + _vm._s(_vm.getPercent(row.role_lose_retention, row.role_lose_num)) + "%） ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "中途退出角色数",
      prop: "role_exit_num",
      align: "center"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "中途退出角色留存",
      prop: "role_exit_retention",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var row = _ref3.row;
        return [_vm._v(" " + _vm._s(row.role_exit_retention) + " （" + _vm._s(_vm.getPercent(row.role_exit_retention, row.role_exit_num)) + "%） ")];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };